import axios from 'axios';
import { EIR_WEBMAIL_CONST } from '../constants/EirWebmailConstants';

const TOKEN = sessionStorage.getItem('WEBMAIL_ADD_TOKEN')
const isCsr = sessionStorage.getItem('WEBMAIL_AUTH_TOKEN')

export const subscriber = axios.create({
    baseURL: `${EIR_WEBMAIL_CONST.url.SUBSCRIBER}/public/webmail`,
    headers: {
        'Authorization': `Bearer ${TOKEN}`
    }
});

export const csrSubscriber = axios.create({
    baseURL: `${EIR_WEBMAIL_CONST.url.PRIVATE_SUBSCRIBER}/public/webmail`,
    headers: {
        'Authorization': `Bearer ${TOKEN}`
    }
});

export const billing = axios.create({
    baseURL: `${EIR_WEBMAIL_CONST.url.INVOICE}/public/webmail/invoice/`,
    headers: {
        'Authorization': `Bearer ${TOKEN}`
    }
});

export const csrBilling = axios.create({
    baseURL: `${EIR_WEBMAIL_CONST.url.PRIVATE_INVOICE}/public/webmail/invoice/`,
    headers: {
        'Authorization': `Bearer ${TOKEN}`
    }
});

export const payer = axios.create({
    baseURL: `${EIR_WEBMAIL_CONST.url.PAYER}/public/auth/payer`,
    headers: {
        'Authorization': `Bearer ${TOKEN}`
    }
})

export const csrPayer = axios.create({
    baseURL: `${EIR_WEBMAIL_CONST.url.PRIVATE_PAYER}/public/auth/payer`,
    headers: {
        'Authorization': `Bearer ${TOKEN}`
    }
})

export const addCard = axios.create({
    baseURL: `${EIR_WEBMAIL_CONST.url.ADD_CARD}/public/auth/payer/addcard`,
    headers: {
        'Authorization': `Bearer ${TOKEN}`
    }
})

export const csrAddCard = axios.create({
    baseURL: `${EIR_WEBMAIL_CONST.url.PRIVATE_ADD_CARD}/public/auth/payer/addcard`,
    headers: {
        'Authorization': `Bearer ${TOKEN}`
    }
})

export const otp = axios.create({
    baseURL: `${EIR_WEBMAIL_CONST.url.OTP}/public`,
    headers: {
        'Authorization': `Bearer ${TOKEN}`
    }
})

export const csrOtp = axios.create({
    baseURL: `${EIR_WEBMAIL_CONST.url.PRIVATE_OTP}/public`,
    headers: {
        'Authorization': `Bearer ${TOKEN}`
    }
})

export const oneOffPayment = axios.create({
    baseURL: isCsr === '0_' ? `${EIR_WEBMAIL_CONST.url.PRIVATE_ONE_OFF_PAYMENT}/public` : `${EIR_WEBMAIL_CONST.url.ONE_OFF_PAYMENT}/public`,
    headers: {
        'Authorization': `Bearer ${TOKEN}`
    }
})